import SEO from "@/components/SEO";
import { BRAND } from "@/brand";
import { Link } from "react-router-dom";

const ITEMS = [
  { img: "/jumbo/images/Group-9181.svg", title: "No upfront fees", body: "There is no signup fee, no listing fee, and no fee for a quote. You only ever see one number: your payout." },
  { img: "/jumbo/images/shield-1.svg", title: "The rate we quote is the rate you get", body: "The number quoted at submission is exactly what we pay on a verified balance. We never reduce it after the fact for any reason other than a balance discrepancy we can document." },
  { img: "/jumbo/images/browser-icon.svg", title: "Most payouts land within 8 hours", body: "Typical processing runs under 8 business hours, up to 48 for cards we need to verify with the issuer. Your status page updates in real time." },
  { img: "/jumbo/images/customizable-icon.svg", title: "Rejections come with reasons", body: "If we can't verify a balance or detect a prior redemption, we explain in writing. You owe us nothing for a rejected submission." },
];

const PROHIBITED = [
  "Cards acquired through phishing, fraud, or theft",
  "Cards purchased with a charged-back or stolen payment instrument",
  "Cards with active disputes against the issuer",
  "Cards listed on other resale platforms simultaneously",
  "Cards from issuers we don't currently support",
];

export default function PricingPage() {
  return (
    <>
      <SEO
        title="Pricing, fees & how payouts work"
        description="A plain-English breakdown of how GC SPARK prices gift cards, when payouts are released, what we charge, and what we cannot accept."
        path="/pricing"
        breadcrumb={[{ name: "Home", path: "/" }, { name: "Pricing", path: "/pricing" }]}
      />

      {/* Theme pricing-section hero */}
      <section className="pricing-section" data-testid="pricing-hero">
        <div className="main-container">
          <div className="pricing-wrapper">
            <div style={{ display: "inline-block", padding: "6px 14px", borderRadius: 90, background: "#0b0d17", color: "#fff", fontSize: 12, fontWeight: 700, letterSpacing: ".12em", textTransform: "uppercase", marginBottom: 22 }}>
              Pricing & fees
            </div>
            <div className="pricing-heading-div">
              <h1 className="h1 _700-bold">Our margin is the spread. <span style={{ color: "#346af8" }}>That's it.</span></h1>
            </div>
            <div className="pricing-para-div">
              <p className="main-body-text-variant-1 _500-medium" style={{ maxWidth: 700 }}>
                We make money on the spread between the rate we pay you and the rate we sell the card for downstream. No hidden charges, no membership tiers, no surprises on your final payout — we published the exact rules below.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Four commitments in security-card style */}
      <section className="security-section" style={{ paddingTop: 40 }} data-testid="pricing-commitments">
        <div className="main-container">
          <div className="security-container">
            <div className="security-heading">
              <h2 className="h2 _700-bold">Four rules that don't move</h2>
            </div>
            <div className="security-card-wrapper" style={{ flexWrap: "wrap" }}>
              {ITEMS.map((it, i) => (
                <div className={`security-card${i === 1 ? " middle-block" : ""}`} key={it.title}>
                  <div className="security-card-image">
                    <img src={it.img} loading="lazy" alt={it.title} />
                  </div>
                  <div className="security-card-title"><div className="h5 _700-bold">{it.title}</div></div>
                  <div className="security-card-para"><div>{it.body}</div></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* What we cannot accept — changelog style */}
      <section className="changelog-section" data-testid="pricing-prohibited" style={{ paddingTop: 40, paddingBottom: 60 }}>
        <div className="main-container w-container">
          <div className="changelog-blocks-container">
            <div className="changelog-heading-container">
              <h2 className="h2 _700-bold">What we can't accept</h2>
            </div>
            <p className="changelog-para" style={{ maxWidth: 700, marginTop: 14, color: "#4a4d5f" }}>
              To keep our platform clean and our partners safe, we won't knowingly buy:
            </p>
            <div className="template-block" style={{ padding: 32, borderRadius: 20, background: "#fff", border: "1px solid #eaeaf0", marginTop: 24 }}>
              <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: 14 }}>
                {PROHIBITED.map((p) => (
                  <li key={p} style={{ display: "flex", gap: 14, alignItems: "flex-start", fontSize: 15, color: "#0b0d17" }}>
                    <div style={{ width: 22, height: 22, borderRadius: "50%", background: "#fee2e2", color: "#dc2626", display: "inline-flex", alignItems: "center", justifyContent: "center", flexShrink: 0, fontSize: 13, fontWeight: 700 }}>×</div>
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
              <p style={{ marginTop: 22, paddingTop: 22, borderTop: "1px solid #eaeaf0", fontSize: 13, color: "#6c6376", lineHeight: 1.6 }}>
                By submitting, you confirm you are {BRAND.minimumAgeYears}+ and that the card is yours and was acquired legally.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="boss-section" data-testid="pricing-cta">
        <div className="boss-container">
          <div className="boss-cta-band">
            <h2>See your rate in 20 seconds</h2>
            <p>Public per-brand rates on the <Link to="/rates" style={{ color: "#8fadff", textDecoration: "underline" }}>rates page</Link>. Submit a card in about three minutes — no fees, no commitment.</p>
            <Link to="/submit" className="boss-btn" data-testid="pricing-cta-sell">Sell a card</Link>
          </div>
        </div>
      </section>
    </>
  );
}
